var userAgent = require('../internals/engine-user-agent');

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/engine-ff-version.js